<ng-container *ngFor="let task of _tasks; let i = index; trackBy: trackByFn">
  <treo-card class="note mt-4 cursor-pointer" (click)="openTask(task)">
    <section class="note-content">
      <!-- Note Header -->
      <article class="note-content__header">
        <!-- Note Title -->
        <div><strong>Task: </strong>{{ task.title }}</div>

        <!-- Date -->
        <div class="date" *ngIf="task.due_date">
          <strong>Due Date: </strong>
          {{ task.due_date | date: 'LLL dd, y, h:mm a' }}
        </div>
      </article>

      <!-- Note body editor -->
      <article class="note-content__note-body">
        <quill-view-html
          [content]="task.description ? task.description : 'No task description...'"
          theme="snow"
        ></quill-view-html>
      </article>

      <mat-divider class="w-full pt-2 pb-2"></mat-divider>
      <article class="note-content__note-footer p-2 flex flex-row justify-between w-full">
        <span class="px-4" *ngIf="task.workflow_state">
          <strong>Status: </strong>
          <label>&nbsp;{{ getTaskStatus(task.workflow_state)?.label }}</label>
        </span>
      </article>
    </section>
  </treo-card>
</ng-container>
